module.exports = __webpack_public_path__ + "img/healthcare.c6fef788.png";